import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetOFPRTNRByOrderId(orderId) {
  const response = await $.soap({
    body: {
      GetOFPRTNRByOrderId: {
        $xmlns: 'http://dla.mil/ems/bpm/order/order_form',
        OrderId: orderId
      }
    },
    blueprint: {
      order: {
        orderId: '$..OrderID',
        itPOCId: '$..ITPOCID',
        ofPrtnr3Id: '$..OF_PRTNR3ID',
        ofPrtnr4Id: '$..OF_PRTNR4ID',
        ofPrtnrProductionId: '$..OF_PRTNRProductionID',
        ofPrtnrOrderTotalId: '$..OF_PRTNRProductionID',
        initialFunding: '$..InitialFunding',
        recurringMonthlyCost: '$..RecurringMonthlyCost',
        numMonthsToFYEnd: '$..NumMonthsToFYEnd',
        miprTotal: '$..MIPRTotal',
        totalFYCost: '$..TotalFYCost',
        customerSignature: '$..CustomerSignature',
        hasBaseAccessReq: '$..HasBaseAccessReq',
        baseAccessReqNotes: '$..BaseAccessReqNotes',
        isArmyCustomer: '$..IsArmyCustomer',
        createdOn: '$..CreatedOn',
        createdBy: '$..CreatedBy',
        updatedOn: '$..UpdatedOn',
        updatedBy: '$..UpdatedBy',
        dateEquipmentReq: '$..DateEquipmentReq',
        firstName: '$..POCFirstName',
        lastName: '$..POCLastName',
        email: '$..POCEmail',
        telephone: '$..POCTelephone',
        finPOCID: '$..FinPOCID'
      }
    }
  });

  cleanUpResponse(response);
  return response.order;
}
